// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://api.fontshare.com/v2/css?f[]=general-sans@701,200,500,301,201,300,601,600,401,501,400,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.3 | MIT License | https://tailwindcss.com
*/
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container{
  width: 100%;
}
@media (min-width: 640px){
  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){
  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){
  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){
  .container{
    max-width: 1280px;
  }
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.inset-0{
  inset: 0px;
}
.bottom-0{
  bottom: 0px;
}
.left-0{
  left: 0px;
}
.left-2{
  left: 0.5rem;
}
.left-4{
  left: 1rem;
}
.left-5{
  left: 1.25rem;
}
.left-\\[-0\\.5px\\]{
  left: -0.5px;
}
.left-\\[-50px\\]{
  left: -50px;
}
.left-\\[0px\\]{
  left: 0px;
}
.left-\\[130px\\]{
  left: 130px;
}
.left-\\[15px\\]{
  left: 15px;
}
.left-\\[42\\%\\]{
  left: 42%;
}
.right-0{
  right: 0px;
}
.right-2{
  right: 0.5rem;
}
.right-4{
  right: 1rem;
}
.right-5{
  right: 1.25rem;
}
.right-6{
  right: 1.5rem;
}
.right-8{
  right: 2rem;
}
.right-\\[-50px\\]{
  right: -50px;
}
.top-0{
  top: 0px;
}
.top-14{
  top: 3.5rem;
}
.top-2{
  top: 0.5rem;
}
.top-24{
  top: 6rem;
}
.top-4{
  top: 1rem;
}
.top-6{
  top: 1.5rem;
}
.top-8{
  top: 2rem;
}
.top-\\[0px\\]{
  top: 0px;
}
.top-\\[12\\.5px\\]{
  top: 12.5px;
}
.top-\\[160px\\]{
  top: 160px;
}
.top-\\[165px\\]{
  top: 165px;
}
.top-\\[380px\\]{
  top: 380px;
}
.top-\\[48px\\]{
  top: 48px;
}
.top-\\[72px\\]{
  top: 72px;
}
.top-\\[80px\\]{
  top: 80px;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[60\\]{
  z-index: 60;
}
.m-0{
  margin: 0px;
}
.m-10{
  margin: 2.5rem;
}
.m-5{
  margin: 1.25rem;
}
.m-auto{
  margin: auto;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-6{
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-0{
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-12{
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-5{
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8{
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-9{
  margin-top: 2.25rem;
  margin-bottom: 2.25rem;
}
.my-\\[18px\\]{
  margin-top: 18px;
  margin-bottom: 18px;
}
.-mt-1{
  margin-top: -0.25rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-12{
  margin-bottom: 3rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-2\\.5{
  margin-bottom: 0.625rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-9{
  margin-bottom: 2.25rem;
}
.mb-\\[10px\\]{
  margin-bottom: 10px;
}
.mb-\\[156px\\]{
  margin-bottom: 156px;
}
.mb-\\[24px\\]{
  margin-bottom: 24px;
}
.ml-0{
  margin-left: 0px;
}
.ml-0\\.5{
  margin-left: 0.125rem;
}
.ml-12{
  margin-left: 3rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-6{
  margin-left: 1.5rem;
}
.ml-7{
  margin-left: 1.75rem;
}
.ml-8{
  margin-left: 2rem;
}
.ml-\\[6px\\]{
  margin-left: 6px;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-4{
  margin-right: 1rem;
}
.mt-0{
  margin-top: 0px;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-20{
  margin-top: 5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-9{
  margin-top: 2.25rem;
}
.mt-\\[100px\\]{
  margin-top: 100px;
}
.mt-\\[120px\\]{
  margin-top: 120px;
}
.mt-\\[150px\\]{
  margin-top: 150px;
}
.mt-\\[20px\\]{
  margin-top: 20px;
}
.mt-\\[32px\\]{
  margin-top: 32px;
}
.mt-\\[40px\\]{
  margin-top: 40px;
}
.mt-\\[48px\\]{
  margin-top: 48px;
}
.mt-\\[70px\\]{
  margin-top: 70px;
}
.mt-\\[72px\\]{
  margin-top: 72px;
}
.mt-auto{
  margin-top: auto;
}
.box-border{
  box-sizing: border-box;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.contents{
  display: contents;
}
.hidden{
  display: none;
}
.size-fit{
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
}
.size-full{
  width: 100%;
  height: 100%;
}
.h-10{
  height: 2.5rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-24{
  height: 6rem;
}
.h-28{
  height: 7rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[100px\\]{
  height: 100px;
}
.h-\\[102px\\]{
  height: 102px;
}
.h-\\[112px\\]{
  height: 112px;
}
.h-\\[120px\\]{
  height: 120px;
}
.h-\\[140px\\]{
  height: 140px;
}
.h-\\[150px\\]{
  height: 150px;
}
.h-\\[154px\\]{
  height: 154px;
}
.h-\\[160px\\]{
  height: 160px;
}
.h-\\[164px\\]{
  height: 164px;
}
.h-\\[180px\\]{
  height: 180px;
}
.h-\\[190px\\]{
  height: 190px;
}
.h-\\[195px\\]{
  height: 195px;
}
.h-\\[204px\\]{
  height: 204px;
}
.h-\\[20px\\]{
  height: 20px;
}
.h-\\[220px\\]{
  height: 220px;
}
.h-\\[22px\\]{
  height: 22px;
}
.h-\\[234px\\]{
  height: 234px;
}
.h-\\[240px\\]{
  height: 240px;
}
.h-\\[250px\\]{
  height: 250px;
}
.h-\\[270px\\]{
  height: 270px;
}
.h-\\[300px\\]{
  height: 300px;
}
.h-\\[320px\\]{
  height: 320px;
}
.h-\\[325px\\]{
  height: 325px;
}
.h-\\[32px\\]{
  height: 32px;
}
.h-\\[36px\\]{
  height: 36px;
}
.h-\\[40px\\]{
  height: 40px;
}
.h-\\[41px\\]{
  height: 41px;
}
.h-\\[442px\\]{
  height: 442px;
}
.h-\\[44px\\]{
  height: 44px;
}
.h-\\[50px\\]{
  height: 50px;
}
.h-\\[512px\\]{
  height: 512px;
}
.h-\\[56px\\]{
  height: 56px;
}
.h-\\[600px\\]{
  height: 600px;
}
.h-\\[60px\\]{
  height: 60px;
}
.h-\\[64px\\]{
  height: 64px;
}
.h-\\[650px\\]{
  height: 650px;
}
.h-\\[66px\\]{
  height: 66px;
}
.h-\\[68px\\]{
  height: 68px;
}
.h-\\[71px\\]{
  height: 71px;
}
.h-\\[72px\\]{
  height: 72px;
}
.h-auto{
  height: auto;
}
.h-fit{
  height: -moz-fit-content;
  height: fit-content;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-20{
  max-height: 5rem;
}
.max-h-\\[375px\\]{
  max-height: 375px;
}
.max-h-\\[376px\\]{
  max-height: 376px;
}
.min-h-0{
  min-height: 0px;
}
.min-h-\\[160px\\]{
  min-height: 160px;
}
.min-h-\\[250px\\]{
  min-height: 250px;
}
.min-h-\\[400px\\]{
  min-height: 400px;
}
.min-h-screen{
  min-height: 100vh;
}
.\\!w-\\[126px\\]{
  width: 126px !important;
}
.\\!w-full{
  width: 100% !important;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-1\\/4{
  width: 25%;
}
.w-10{
  width: 2.5rem;
}
.w-14{
  width: 3.5rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\/3{
  width: 66.666667%;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3\\/4{
  width: 75%;
}
.w-32{
  width: 8rem;
}
.w-4{
  width: 1rem;
}
.w-4\\/5{
  width: 80%;
}
.w-5{
  width: 1.25rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[100\\%\\]{
  width: 100%;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[112px\\]{
  width: 112px;
}
.w-\\[1130px\\]{
  width: 1130px;
}
.w-\\[120px\\]{
  width: 120px;
}
.w-\\[126px\\]{
  width: 126px;
}
.w-\\[127px\\]{
  width: 127px;
}
.w-\\[135px\\]{
  width: 135px;
}
.w-\\[1440px\\]{
  width: 1440px;
}
.w-\\[150px\\]{
  width: 150px;
}
.w-\\[156px\\]{
  width: 156px;
}
.w-\\[178px\\]{
  width: 178px;
}
.w-\\[180px\\]{
  width: 180px;
}
.w-\\[185px\\]{
  width: 185px;
}
.w-\\[20\\]{
  width: 20;
}
.w-\\[235px\\]{
  width: 235px;
}
.w-\\[250px\\]{
  width: 250px;
}
.w-\\[270px\\]{
  width: 270px;
}
.w-\\[280px\\]{
  width: 280px;
}
.w-\\[290px\\]{
  width: 290px;
}
.w-\\[300px\\]{
  width: 300px;
}
.w-\\[315px\\]{
  width: 315px;
}
.w-\\[327px\\]{
  width: 327px;
}
.w-\\[32px\\]{
  width: 32px;
}
.w-\\[330px\\]{
  width: 330px;
}
.w-\\[355px\\]{
  width: 355px;
}
.w-\\[36px\\]{
  width: 36px;
}
.w-\\[41px\\]{
  width: 41px;
}
.w-\\[420px\\]{
  width: 420px;
}
.w-\\[45\\%\\]{
  width: 45%;
}
.w-\\[472px\\]{
  width: 472px;
}
.w-\\[502px\\]{
  width: 502px;
}
.w-\\[512px\\]{
  width: 512px;
}
.w-\\[51px\\]{
  width: 51px;
}
.w-\\[520px\\]{
  width: 520px;
}
.w-\\[58px\\]{
  width: 58px;
}
.w-\\[600px\\]{
  width: 600px;
}
.w-\\[640px\\]{
  width: 640px;
}
.w-\\[660px\\]{
  width: 660px;
}
.w-\\[66px\\]{
  width: 66px;
}
.w-\\[68px\\]{
  width: 68px;
}
.w-\\[70\\%\\]{
  width: 70%;
}
.w-\\[80\\%\\]{
  width: 80%;
}
.w-\\[811px\\]{
  width: 811px;
}
.w-\\[88px\\]{
  width: 88px;
}
.w-\\[92px\\]{
  width: 92px;
}
.w-\\[95\\%\\]{
  width: 95%;
}
.w-auto{
  width: auto;
}
.w-fit{
  width: -moz-fit-content;
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-screen{
  width: 100vw;
}
.min-w-0{
  min-width: 0px;
}
.min-w-\\[280px\\]{
  min-width: 280px;
}
.min-w-\\[400px\\]{
  min-width: 400px;
}
.min-w-\\[800px\\]{
  min-width: 800px;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-\\[1151px\\]{
  max-width: 1151px;
}
.max-w-\\[330px\\]{
  max-width: 330px;
}
.max-w-\\[375px\\]{
  max-width: 375px;
}
.max-w-\\[420px\\]{
  max-width: 420px;
}
.max-w-\\[600px\\]{
  max-width: 600px;
}
.max-w-\\[660px\\]{
  max-width: 660px;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-screen-xl{
  max-width: 1280px;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1 0%;
}
.flex-shrink{
  flex-shrink: 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.grow{
  flex-grow: 1;
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-scale-x-100{
  --tw-scale-x: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse{
  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.resize{
  resize: both;
}
.list-inside{
  list-style-position: inside;
}
.list-disc{
  list-style-type: disc;
}
.appearance-none{
  appearance: none;
}
.grid-flow-col{
  grid-auto-flow: column;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-rows-2{
  grid-template-rows: repeat(2, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.flex-nowrap{
  flex-wrap: nowrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.justify-evenly{
  justify-content: space-evenly;
}
.justify-stretch{
  justify-content: stretch;
}
.gap-0{
  gap: 0px;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-12{
  gap: 3rem;
}
.gap-14{
  gap: 3.5rem;
}
.gap-16{
  gap: 4rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-20{
  gap: 5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-7{
  gap: 1.75rem;
}
.gap-8{
  gap: 2rem;
}
.gap-9{
  gap: 2.25rem;
}
.gap-\\[10px\\]{
  gap: 10px;
}
.gap-\\[12px\\]{
  gap: 12px;
}
.gap-\\[15vw\\]{
  gap: 15vw;
}
.gap-\\[16px\\]{
  gap: 16px;
}
.gap-\\[18px\\]{
  gap: 18px;
}
.gap-\\[20px\\]{
  gap: 20px;
}
.gap-\\[24px\\]{
  gap: 24px;
}
.gap-\\[2px\\]{
  gap: 2px;
}
.gap-\\[36px\\]{
  gap: 36px;
}
.gap-\\[40px\\]{
  gap: 40px;
}
.gap-\\[48px\\]{
  gap: 48px;
}
.gap-\\[60px\\]{
  gap: 60px;
}
.gap-\\[6px\\]{
  gap: 6px;
}
.gap-y-8{
  row-gap: 2rem;
}
.space-x-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.self-start{
  align-self: flex-start;
}
.self-end{
  align-self: flex-end;
}
.self-center{
  align-self: center;
}
.self-stretch{
  align-self: stretch;
}
.self-baseline{
  align-self: baseline;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overflow-y-hidden{
  overflow-y: hidden;
}
.overflow-y-scroll{
  overflow-y: scroll;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.overflow-ellipsis{
  text-overflow: ellipsis;
}
.text-ellipsis{
  text-overflow: ellipsis;
}
.whitespace-normal{
  white-space: normal;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.text-nowrap{
  text-wrap: nowrap;
}
.break-normal{
  overflow-wrap: normal;
  word-break: normal;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[12px\\]{
  border-radius: 12px;
}
.rounded-\\[13px\\]{
  border-radius: 13px;
}
.rounded-\\[20px\\]{
  border-radius: 20px;
}
.rounded-\\[24px\\]{
  border-radius: 24px;
}
.rounded-\\[36px\\]{
  border-radius: 36px;
}
.rounded-\\[40px\\]{
  border-radius: 40px;
}
.rounded-\\[4px\\]{
  border-radius: 4px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-none{
  border-radius: 0px;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-3xl{
  border-bottom-right-radius: 1.5rem;
  border-bottom-left-radius: 1.5rem;
}
.rounded-b-\\[24px\\]{
  border-bottom-right-radius: 24px;
  border-bottom-left-radius: 24px;
}
.rounded-b-md{
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-b-xl{
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-e-xl{
  border-start-end-radius: 0.75rem;
  border-end-end-radius: 0.75rem;
}
.rounded-r-lg{
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-s-xl{
  border-start-start-radius: 0.75rem;
  border-end-start-radius: 0.75rem;
}
.rounded-t-3xl{
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}
.rounded-t-\\[24px\\]{
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
}
.rounded-t-lg{
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-t-xl{
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.border{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-\\[0\\.5px\\]{
  border-width: 0.5px;
}
.border-\\[1px\\]{
  border-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-t-\\[1px\\]{
  border-top-width: 1px;
}
.border-solid{
  border-style: solid;
}
.border-dashed{
  border-style: dashed;
}
.border-none{
  border-style: none;
}
.border-\\[\\#68944E\\]{
  --tw-border-opacity: 1;
  border-color: rgb(104 148 78 / var(--tw-border-opacity));
}
.border-\\[\\#B7B7B7\\]{
  --tw-border-opacity: 1;
  border-color: rgb(183 183 183 / var(--tw-border-opacity));
}
.border-\\[\\#B8B8B8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(184 184 184 / var(--tw-border-opacity));
}
.border-\\[\\#C28951\\]{
  --tw-border-opacity: 1;
  border-color: rgb(194 137 81 / var(--tw-border-opacity));
}
.border-\\[\\#D9D9D9\\]{
  --tw-border-opacity: 1;
  border-color: rgb(217 217 217 / var(--tw-border-opacity));
}
.border-\\[\\#DED300\\]{
  --tw-border-opacity: 1;
  border-color: rgb(222 211 0 / var(--tw-border-opacity));
}
.border-\\[\\#E7E7E7\\]{
  --tw-border-opacity: 1;
  border-color: rgb(231 231 231 / var(--tw-border-opacity));
}
.border-\\[\\#ff24591a\\]{
  border-color: #ff24591a;
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(16 16 16 / var(--tw-border-opacity));
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
.border-grey-10{
  --tw-border-opacity: 1;
  border-color: rgb(243 243 243 / var(--tw-border-opacity));
}
.border-grey-200{
  --tw-border-opacity: 1;
  border-color: rgb(234 236 240 / var(--tw-border-opacity));
}
.border-grey-30{
  --tw-border-opacity: 1;
  border-color: rgb(231 231 231 / var(--tw-border-opacity));
}
.border-grey-5{
  --tw-border-opacity: 1;
  border-color: rgb(248 248 248 / var(--tw-border-opacity));
}
.border-grey-50{
  --tw-border-opacity: 1;
  border-color: rgb(183 183 183 / var(--tw-border-opacity));
}
.border-grey-70{
  --tw-border-opacity: 1;
  border-color: rgb(113 113 113 / var(--tw-border-opacity));
}
.border-pink-500{
  --tw-border-opacity: 1;
  border-color: rgb(236 72 153 / var(--tw-border-opacity));
}
.border-primary{
  --tw-border-opacity: 1;
  border-color: rgb(255 36 89 / var(--tw-border-opacity));
}
.border-red-200\\/50{
  border-color: rgb(254 202 202 / 0.5);
}
.border-transparent{
  border-color: transparent;
}
.border-y-grey-5{
  --tw-border-opacity: 1;
  border-top-color: rgb(248 248 248 / var(--tw-border-opacity));
  border-bottom-color: rgb(248 248 248 / var(--tw-border-opacity));
}
.border-b-primary{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(255 36 89 / var(--tw-border-opacity));
}
.border-t-\\[\\#F3F3F3\\]{
  --tw-border-opacity: 1;
  border-top-color: rgb(243 243 243 / var(--tw-border-opacity));
}
.border-t-\\[\\#FFF2F2\\]{
  --tw-border-opacity: 1;
  border-top-color: rgb(255 242 242 / var(--tw-border-opacity));
}
.border-t-grey-10{
  --tw-border-opacity: 1;
  border-top-color: rgb(243 243 243 / var(--tw-border-opacity));
}
.border-t-primary{
  --tw-border-opacity: 1;
  border-top-color: rgb(255 36 89 / var(--tw-border-opacity));
}
.bg-\\[\\#009D641A\\]{
  background-color: #009D641A;
}
.bg-\\[\\#101010\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(16 16 16 / var(--tw-bg-opacity));
}
.bg-\\[\\#1A1A1A\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(26 26 26 / var(--tw-bg-opacity));
}
.bg-\\[\\#D92D201A\\]{
  background-color: #D92D201A;
}
.bg-\\[\\#DFEFD7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(223 239 215 / var(--tw-bg-opacity));
}
.bg-\\[\\#E5FFF6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(229 255 246 / var(--tw-bg-opacity));
}
.bg-\\[\\#F32455\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 36 85 / var(--tw-bg-opacity));
}
.bg-\\[\\#F3F3F3\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 243 243 / var(--tw-bg-opacity));
}
.bg-\\[\\#F8F8F8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 248 248 / var(--tw-bg-opacity));
}
.bg-\\[\\#FAE4D0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(250 228 208 / var(--tw-bg-opacity));
}
.bg-\\[\\#FBEAE9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(251 234 233 / var(--tw-bg-opacity));
}
.bg-\\[\\#FDFDFD\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(253 253 253 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFE8EF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 232 239 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFF2F2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 242 242 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFF4F4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 244 244 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFF5DB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 245 219 / var(--tw-bg-opacity));
}
.bg-\\[\\#fff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(16 16 16 / var(--tw-bg-opacity));
}
.bg-error{
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-900{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
.bg-green-200{
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity));
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity));
}
.bg-grey-10{
  --tw-bg-opacity: 1;
  background-color: rgb(243 243 243 / var(--tw-bg-opacity));
}
.bg-grey-30{
  --tw-bg-opacity: 1;
  background-color: rgb(231 231 231 / var(--tw-bg-opacity));
}
.bg-grey-5{
  --tw-bg-opacity: 1;
  background-color: rgb(248 248 248 / var(--tw-bg-opacity));
}
.bg-grey-50{
  --tw-bg-opacity: 1;
  background-color: rgb(183 183 183 / var(--tw-bg-opacity));
}
.bg-light{
  --tw-bg-opacity: 1;
  background-color: rgb(255 242 242 / var(--tw-bg-opacity));
}
.bg-light-green{
  --tw-bg-opacity: 1;
  background-color: rgb(229 255 246 / var(--tw-bg-opacity));
}
.bg-light-white{
  --tw-bg-opacity: 1;
  background-color: rgb(253 253 253 / var(--tw-bg-opacity));
}
.bg-neutral-700{
  --tw-bg-opacity: 1;
  background-color: rgb(64 64 64 / var(--tw-bg-opacity));
}
.bg-pink-100{
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / var(--tw-bg-opacity));
}
.bg-pink-50{
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity));
}
.bg-primary{
  --tw-bg-opacity: 1;
  background-color: rgb(255 36 89 / var(--tw-bg-opacity));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(253 253 253 / var(--tw-bg-opacity));
}
.bg-opacity-5{
  --tw-bg-opacity: 0.05;
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-opacity-80{
  --tw-bg-opacity: 0.8;
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.from-\\[\\#ffd6e0\\]{
  --tw-gradient-from: #ffd6e0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 214 224 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#fff2f2\\]{
  --tw-gradient-from: #fff2f2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 242 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-5\\%{
  --tw-gradient-from-position: 5%;
}
.to-\\[\\#fcdfe9\\]{
  --tw-gradient-to: #fcdfe9 var(--tw-gradient-to-position);
}
.to-\\[\\#fff\\]{
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.to-95\\%{
  --tw-gradient-to-position: 95%;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.object-fill{
  object-fit: fill;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-32{
  padding: 8rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-9{
  padding: 2.25rem;
}
.p-\\[10px\\]{
  padding: 10px;
}
.p-\\[12px\\]{
  padding: 12px;
}
.p-\\[14\\.571px\\]{
  padding: 14.571px;
}
.p-\\[24px\\]{
  padding: 24px;
}
.p-\\[6px\\]{
  padding: 6px;
}
.p-\\[7px\\]{
  padding: 7px;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5{
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-12{
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-14{
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}
.px-16{
  padding-left: 4rem;
  padding-right: 4rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-20{
  padding-left: 5rem;
  padding-right: 5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-32{
  padding-left: 8rem;
  padding-right: 8rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-9{
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}
.px-\\[13px\\]{
  padding-left: 13px;
  padding-right: 13px;
}
.px-\\[18px\\]{
  padding-left: 18px;
  padding-right: 18px;
}
.px-\\[6px\\]{
  padding-left: 6px;
  padding-right: 6px;
}
.px-\\[80px\\]{
  padding-left: 80px;
  padding-right: 80px;
}
.px-\\[8px\\]{
  padding-left: 8px;
  padding-right: 8px;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-9{
  padding-top: 2.25rem;
  padding-bottom: 2.25rem;
}
.py-\\[100px\\]{
  padding-top: 100px;
  padding-bottom: 100px;
}
.py-\\[18px\\]{
  padding-top: 18px;
  padding-bottom: 18px;
}
.py-\\[2px\\]{
  padding-top: 2px;
  padding-bottom: 2px;
}
.py-\\[4px\\]{
  padding-top: 4px;
  padding-bottom: 4px;
}
.py-\\[6px\\]{
  padding-top: 6px;
  padding-bottom: 6px;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-12{
  padding-bottom: 3rem;
}
.pb-16{
  padding-bottom: 4rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-24{
  padding-bottom: 6rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-32{
  padding-bottom: 8rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-7{
  padding-bottom: 1.75rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pb-9{
  padding-bottom: 2.25rem;
}
.pb-\\[104px\\]{
  padding-bottom: 104px;
}
.pb-\\[10px\\]{
  padding-bottom: 10px;
}
.pb-\\[15px\\]{
  padding-bottom: 15px;
}
.pb-\\[30px\\]{
  padding-bottom: 30px;
}
.pb-\\[64px\\]{
  padding-bottom: 64px;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-12{
  padding-left: 3rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pl-\\[18px\\]{
  padding-left: 18px;
}
.pr-0{
  padding-right: 0px;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-5{
  padding-right: 1.25rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-9{
  padding-right: 2.25rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-11{
  padding-top: 2.75rem;
}
.pt-16{
  padding-top: 4rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-24{
  padding-top: 6rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-7{
  padding-top: 1.75rem;
}
.pt-8{
  padding-top: 2rem;
}
.pt-9{
  padding-top: 2.25rem;
}
.pt-\\[151px\\]{
  padding-top: 151px;
}
.pt-\\[36px\\]{
  padding-top: 36px;
}
.pt-\\[42px\\]{
  padding-top: 42px;
}
.pt-\\[46px\\]{
  padding-top: 46px;
}
.pt-\\[50px\\]{
  padding-top: 50px;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.text-justify{
  text-align: justify;
}
.text-start{
  text-align: start;
}
.align-middle{
  vertical-align: middle;
}
.font-general-sans{
  font-family: General Sans, sans-serif;
}
.font-sans{
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.font-satoshi{
  font-family: Satoshi, sans-serif;
}
.font-times{
  font-family: "Times New Roman", serif;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-\\[100px\\]{
  font-size: 100px;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[22px\\]{
  font-size: 22px;
}
.text-\\[24px\\]{
  font-size: 24px;
}
.text-\\[32px\\]{
  font-size: 32px;
}
.text-\\[40px\\]{
  font-size: 40px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-\\[500\\]{
  font-weight: 500;
}
.font-\\[600\\]{
  font-weight: 600;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.italic{
  font-style: italic;
}
.not-italic{
  font-style: normal;
}
.\\!leading-\\[18px\\]{
  line-height: 18px !important;
}
.\\!leading-\\[unset\\]{
  line-height: unset !important;
}
.leading-5{
  line-height: 1.25rem;
}
.leading-\\[102\\.7\\%\\]{
  line-height: 102.7%;
}
.leading-\\[104\\%\\]{
  line-height: 104%;
}
.leading-\\[125\\%\\]{
  line-height: 125%;
}
.leading-\\[135\\%\\]{
  line-height: 135%;
}
.leading-\\[20px\\]{
  line-height: 20px;
}
.leading-\\[40px\\]{
  line-height: 40px;
}
.leading-normal{
  line-height: 1.5;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[-0\\.02em\\]{
  letter-spacing: -0.02em;
}
.tracking-\\[-0\\.5px\\]{
  letter-spacing: -0.5px;
}
.tracking-\\[-1px\\]{
  letter-spacing: -1px;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.\\!text-primary{
  --tw-text-opacity: 1 !important;
  color: rgb(255 36 89 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#009D64\\]{
  --tw-text-opacity: 1;
  color: rgb(0 157 100 / var(--tw-text-opacity));
}
.text-\\[\\#101010\\]{
  --tw-text-opacity: 1;
  color: rgb(16 16 16 / var(--tw-text-opacity));
}
.text-\\[\\#23AB37\\]{
  --tw-text-opacity: 1;
  color: rgb(35 171 55 / var(--tw-text-opacity));
}
.text-\\[\\#68944E\\]{
  --tw-text-opacity: 1;
  color: rgb(104 148 78 / var(--tw-text-opacity));
}
.text-\\[\\#717171\\]{
  --tw-text-opacity: 1;
  color: rgb(113 113 113 / var(--tw-text-opacity));
}
.text-\\[\\#878787\\]{
  --tw-text-opacity: 1;
  color: rgb(135 135 135 / var(--tw-text-opacity));
}
.text-\\[\\#C28951\\]{
  --tw-text-opacity: 1;
  color: rgb(194 137 81 / var(--tw-text-opacity));
}
.text-\\[\\#D92D20\\]{
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity));
}
.text-\\[\\#FF2459\\]{
  --tw-text-opacity: 1;
  color: rgb(255 36 89 / var(--tw-text-opacity));
}
.text-\\[\\#FF3C6B\\]{
  --tw-text-opacity: 1;
  color: rgb(255 60 107 / var(--tw-text-opacity));
}
.text-\\[green\\]{
  --tw-text-opacity: 1;
  color: rgb(0 128 0 / var(--tw-text-opacity));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(16 16 16 / var(--tw-text-opacity));
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}
.text-error{
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
}
.text-grey-50{
  --tw-text-opacity: 1;
  color: rgb(183 183 183 / var(--tw-text-opacity));
}
.text-grey-70{
  --tw-text-opacity: 1;
  color: rgb(113 113 113 / var(--tw-text-opacity));
}
.text-pink-600{
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity));
}
.text-primary{
  --tw-text-opacity: 1;
  color: rgb(255 36 89 / var(--tw-text-opacity));
}
.text-primary-green{
  --tw-text-opacity: 1;
  color: rgb(0 157 100 / var(--tw-text-opacity));
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-rose-500{
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity));
}
.text-slate-950{
  --tw-text-opacity: 1;
  color: rgb(2 6 23 / var(--tw-text-opacity));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(253 253 253 / var(--tw-text-opacity));
}
.text-yellow{
  --tw-text-opacity: 1;
  color: rgb(226 232 20 / var(--tw-text-opacity));
}
.underline{
  text-decoration-line: underline;
}
.no-underline{
  text-decoration-line: none;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.accent-grey-5{
  accent-color: #F8F8F8;
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-flat{
  --tw-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  --tw-shadow-colored: 0px 1px 2px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[18px\\]{
  --tw-blur: blur(18px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-lg{
  --tw-drop-shadow: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert{
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.sepia{
  --tw-sepia: sepia(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow{
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
html,
body {
  font-family: "General Sans", "Sans Serif";
  width: 100%;
  height: 100%;
}

.heading-64 {
  font-weight: 700;
  font-size: 64px;
  line-height: 80px;
}

.heading-48 {
  font-weight: 600;
  font-size: 48px;
  line-height: 57.6px;
}

.heading-36 {
  font-weight: 600;
  font-size: 36px;
  line-height: 44.28px;
}

.heading-24 {
  font-weight: 600;
  font-size: 24px;
  line-height: 32.4px;
}

.heading-16 {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
}

.heading-18 {
  font-weight: 600;
  font-size: 18px;
  line-height: normal;
}

.label-18 {
  font-weight: 500;
  font-size: 18px;
  line-height: 24.3px;
}

.label-16 {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
}

.label-14 {
  font-weight: 500;
  font-size: 14px;
  line-height: 16.1px;
}

.label-12 {
  font-weight: 500;
  font-size: 12px;
  line-height: 12.48px;
}

.text-18 {
  font-weight: 400;
  font-size: 18px;
  line-height: 24.3px;
}

.text-16 {
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
}

.text-14 {
  font-weight: 400;
  font-size: 14px;
  line-height: 19.6px;
}

.text-12 {
  font-weight: 400;
  font-size: 12px;
  line-height: 15.6px;
}

.text-cta {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
}

.shadow-xs, .toggle-wrapper .toggle-select::after {
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.shadow-sm {
  box-shadow: 0px 1px 3px 0px rgba(16, 24, 40, 0.1), 0px 1px 2px 0px rgba(16, 24, 40, 0.06);
}

.shadow-md {
  box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06);
}

.shadow-lg {
  box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
}

.shadow-xl {
  box-shadow: 0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03);
}

.shadow-2xl {
  box-shadow: 0px 24px 48px -12px rgba(16, 24, 40, 0.18);
}

.shadow-3xl {
  box-shadow: 0px 32px 64px -12px rgba(16, 24, 40, 0.14);
}

.horizontal-divider {
  height: 1px;
  width: 100%;
  background: #B7B7B7;
  opacity: 0.2;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  z-index: 10;
}

::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 100px;
}

::-webkit-scrollbar-thumb {
  border-radius: 100px;
  border: 2px solid transparent;
  background-clip: content-box;
  background-color: #E7E7E7;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.loader-icon {
  animation: spin 1000ms linear infinite;
}

.required::after {
  content: "*";
  color: #D92D20;
  margin-left: 2px;
}

.toggle-wrapper .label-wrapper .label {
  color: #101010;
}
.toggle-wrapper .label-wrapper .sub-text {
  color: #717171;
}
.toggle-wrapper .toggle-select {
  width: 44px;
  height: 24px;
  border-radius: 50px;
  background-color: #E7E7E7;
  transition: background-color 0.5s ease;
}
.toggle-wrapper .toggle-select::after {
  content: "";
  position: absolute;
  background-color: #FDFDFD;
  border-radius: 50%;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
}
.toggle-wrapper:not(.disabled):not(.checked):hover .toggle-select {
  background-color: #B7B7B7;
}
.toggle-wrapper.checked .toggle-select {
  background-color: #009D64;
}
.toggle-wrapper.checked .toggle-select::after {
  left: 22px;
}
.toggle-wrapper.disabled {
  cursor: not-allowed;
}
.toggle-wrapper.disabled .label-wrapper .label,
.toggle-wrapper.disabled .label-wrapper .sub-text {
  color: #B7B7B7;
}
.toggle-wrapper .checkmark {
  right: 5px;
  top: 5px;
  z-index: 1;
}
.hover\\:border-black:hover{
  --tw-border-opacity: 1;
  border-color: rgb(16 16 16 / var(--tw-border-opacity));
}
.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 253 253 / var(--tw-bg-opacity));
}
.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.active\\:scale-\\[0\\.98\\]:active{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.disabled\\:bg-gray-300:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
@media (min-width: 640px){
  .sm\\:w-1\\/2{
    width: 50%;
  }
  .sm\\:w-\\[583px\\]{
    width: 583px;
  }
  .sm\\:w-full{
    width: 100%;
  }
  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .sm\\:flex-row{
    flex-direction: row;
  }
  .sm\\:gap-\\[24px\\]{
    gap: 24px;
  }
  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .sm\\:pt-3{
    padding-top: 0.75rem;
  }
  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 768px){
  .md\\:visible{
    visibility: visible;
  }
  .md\\:static{
    position: static;
  }
  .md\\:fixed{
    position: fixed;
  }
  .md\\:absolute{
    position: absolute;
  }
  .md\\:relative{
    position: relative;
  }
  .md\\:bottom-\\[130px\\]{
    bottom: 130px;
  }
  .md\\:left-\\[28px\\]{
    left: 28px;
  }
  .md\\:left-\\[calc\\(50\\%_-_11px\\)\\]{
    left: calc(50% - 11px);
  }
  .md\\:m-auto{
    margin: auto;
  }
  .md\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }
  .md\\:mb-14{
    margin-bottom: 3.5rem;
  }
  .md\\:mb-8{
    margin-bottom: 2rem;
  }
  .md\\:mb-auto{
    margin-bottom: auto;
  }
  .md\\:ml-auto{
    margin-left: auto;
  }
  .md\\:mt-0{
    margin-top: 0px;
  }
  .md\\:mt-24{
    margin-top: 6rem;
  }
  .md\\:mt-\\[100px\\]{
    margin-top: 100px;
  }
  .md\\:block{
    display: block;
  }
  .md\\:inline{
    display: inline;
  }
  .md\\:flex{
    display: flex;
  }
  .md\\:hidden{
    display: none;
  }
  .md\\:h-10{
    height: 2.5rem;
  }
  .md\\:h-\\[100\\%\\]{
    height: 100%;
  }
  .md\\:h-\\[100px\\]{
    height: 100px;
  }
  .md\\:h-\\[235px\\]{
    height: 235px;
  }
  .md\\:h-\\[240px\\]{
    height: 240px;
  }
  .md\\:h-\\[280px\\]{
    height: 280px;
  }
  .md\\:h-\\[300px\\]{
    height: 300px;
  }
  .md\\:h-\\[420px\\]{
    height: 420px;
  }
  .md\\:h-\\[460px\\]{
    height: 460px;
  }
  .md\\:h-\\[480px\\]{
    height: 480px;
  }
  .md\\:h-\\[68px\\]{
    height: 68px;
  }
  .md\\:h-\\[72px\\]{
    height: 72px;
  }
  .md\\:h-auto{
    height: auto;
  }
  .md\\:h-full{
    height: 100%;
  }
  .md\\:h-screen{
    height: 100vh;
  }
  .md\\:w-1\\/2{
    width: 50%;
  }
  .md\\:w-1\\/3{
    width: 33.333333%;
  }
  .md\\:w-3\\/4{
    width: 75%;
  }
  .md\\:w-\\[110\\%\\]{
    width: 110%;
  }
  .md\\:w-\\[126px\\]{
    width: 126px;
  }
  .md\\:w-\\[180px\\]{
    width: 180px;
  }
  .md\\:w-\\[200px\\]{
    width: 200px;
  }
  .md\\:w-\\[220px\\]{
    width: 220px;
  }
  .md\\:w-\\[230px\\]{
    width: 230px;
  }
  .md\\:w-\\[250px\\]{
    width: 250px;
  }
  .md\\:w-\\[280px\\]{
    width: 280px;
  }
  .md\\:w-\\[330px\\]{
    width: 330px;
  }
  .md\\:w-\\[40\\%\\]{
    width: 40%;
  }
  .md\\:w-\\[420px\\]{
    width: 420px;
  }
  .md\\:w-\\[430px\\]{
    width: 430px;
  }
  .md\\:w-\\[45\\%\\]{
    width: 45%;
  }
  .md\\:w-\\[475px\\]{
    width: 475px;
  }
  .md\\:w-\\[50\\%\\]{
    width: 50%;
  }
  .md\\:w-\\[540px\\]{
    width: 540px;
  }
  .md\\:w-\\[55\\%\\]{
    width: 55%;
  }
  .md\\:w-\\[560px\\]{
    width: 560px;
  }
  .md\\:w-\\[630px\\]{
    width: 630px;
  }
  .md\\:w-\\[65\\%\\]{
    width: 65%;
  }
  .md\\:w-\\[68px\\]{
    width: 68px;
  }
  .md\\:w-\\[70\\%\\]{
    width: 70%;
  }
  .md\\:w-\\[811px\\]{
    width: 811px;
  }
  .md\\:w-auto{
    width: auto;
  }
  .md\\:w-full{
    width: 100%;
  }
  .md\\:w-max{
    width: max-content;
  }
  .md\\:max-w-3xl{
    max-width: 48rem;
  }
  .md\\:max-w-5xl{
    max-width: 64rem;
  }
  .md\\:max-w-7xl{
    max-width: 80rem;
  }
  .md\\:max-w-\\[1690px\\]{
    max-width: 1690px;
  }
  .md\\:max-w-\\[330px\\]{
    max-width: 330px;
  }
  .md\\:max-w-\\[600px\\]{
    max-width: 600px;
  }
  .md\\:max-w-\\[640px\\]{
    max-width: 640px;
  }
  .md\\:max-w-\\[670px\\]{
    max-width: 670px;
  }
  .md\\:flex-1{
    flex: 1 1 0%;
  }
  .md\\:grow{
    flex-grow: 1;
  }
  .md\\:basis-0{
    flex-basis: 0px;
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:flex-row{
    flex-direction: row;
  }
  .md\\:items-start{
    align-items: flex-start;
  }
  .md\\:items-center{
    align-items: center;
  }
  .md\\:justify-start{
    justify-content: flex-start;
  }
  .md\\:justify-center{
    justify-content: center;
  }
  .md\\:justify-between{
    justify-content: space-between;
  }
  .md\\:justify-evenly{
    justify-content: space-evenly;
  }
  .md\\:gap-0{
    gap: 0px;
  }
  .md\\:gap-1{
    gap: 0.25rem;
  }
  .md\\:gap-10{
    gap: 2.5rem;
  }
  .md\\:gap-16{
    gap: 4rem;
  }
  .md\\:gap-2{
    gap: 0.5rem;
  }
  .md\\:gap-20{
    gap: 5rem;
  }
  .md\\:gap-24{
    gap: 6rem;
  }
  .md\\:gap-28{
    gap: 7rem;
  }
  .md\\:gap-4{
    gap: 1rem;
  }
  .md\\:gap-5{
    gap: 1.25rem;
  }
  .md\\:gap-8{
    gap: 2rem;
  }
  .md\\:gap-\\[20px\\]{
    gap: 20px;
  }
  .md\\:gap-\\[25px\\]{
    gap: 25px;
  }
  .md\\:gap-\\[40px\\]{
    gap: 40px;
  }
  .md\\:self-start{
    align-self: flex-start;
  }
  .md\\:overflow-auto{
    overflow: auto;
  }
  .md\\:overflow-hidden{
    overflow: hidden;
  }
  .md\\:overflow-y-hidden{
    overflow-y: hidden;
  }
  .md\\:rounded-\\[20px\\]{
    border-radius: 20px;
  }
  .md\\:border-r{
    border-right-width: 1px;
  }
  .md\\:bg-grey-5{
    --tw-bg-opacity: 1;
    background-color: rgb(248 248 248 / var(--tw-bg-opacity));
  }
  .md\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(253 253 253 / var(--tw-bg-opacity));
  }
  .md\\:p-0{
    padding: 0px;
  }
  .md\\:p-10{
    padding: 2.5rem;
  }
  .md\\:p-3{
    padding: 0.75rem;
  }
  .md\\:p-5{
    padding: 1.25rem;
  }
  .md\\:p-8{
    padding: 2rem;
  }
  .md\\:p-\\[20px\\]{
    padding: 20px;
  }
  .md\\:p-\\[50px\\]{
    padding: 50px;
  }
  .md\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }
  .md\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .md\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }
  .md\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .md\\:px-20{
    padding-left: 5rem;
    padding-right: 5rem;
  }
  .md\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .md\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .md\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .md\\:px-\\[13\\.103\\%\\]{
    padding-left: 13.103%;
    padding-right: 13.103%;
  }
  .md\\:px-\\[130px\\]{
    padding-left: 130px;
    padding-right: 130px;
  }
  .md\\:px-\\[24px\\]{
    padding-left: 24px;
    padding-right: 24px;
  }
  .md\\:px-\\[42px\\]{
    padding-left: 42px;
    padding-right: 42px;
  }
  .md\\:px-\\[50px\\]{
    padding-left: 50px;
    padding-right: 50px;
  }
  .md\\:px-\\[80px\\]{
    padding-left: 80px;
    padding-right: 80px;
  }
  .md\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .md\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .md\\:py-16{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
  .md\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .md\\:py-20{
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
  .md\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .md\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .md\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .md\\:py-7{
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
  .md\\:py-9{
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }
  .md\\:py-\\[120px\\]{
    padding-top: 120px;
    padding-bottom: 120px;
  }
  .md\\:py-\\[50px\\]{
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .md\\:py-\\[80px\\]{
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .md\\:pb-12{
    padding-bottom: 3rem;
  }
  .md\\:pb-5{
    padding-bottom: 1.25rem;
  }
  .md\\:pb-\\[120px\\]{
    padding-bottom: 120px;
  }
  .md\\:pr-6{
    padding-right: 1.5rem;
  }
  .md\\:pt-4{
    padding-top: 1rem;
  }
  .md\\:pt-6{
    padding-top: 1.5rem;
  }
  .md\\:pt-7{
    padding-top: 1.75rem;
  }
  .md\\:pt-8{
    padding-top: 2rem;
  }
  .md\\:text-left{
    text-align: left;
  }
  .md\\:text-start{
    text-align: start;
  }
  .md\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .md\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .md\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }
  .md\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }
  .md\\:text-\\[30px\\]{
    font-size: 30px;
  }
  .md\\:text-\\[48px\\]{
    font-size: 48px;
  }
  .md\\:text-\\[56px\\]{
    font-size: 56px;
  }
  .md\\:text-\\[60px\\]{
    font-size: 60px;
  }
  .md\\:text-\\[64px\\]{
    font-size: 64px;
  }
  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .md\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .md\\:font-bold{
    font-weight: 700;
  }
  .md\\:leading-\\[123\\%\\]{
    line-height: 123%;
  }
  .md\\:leading-snug{
    line-height: 1.375;
  }
  .md\\:leading-tight{
    line-height: 1.25;
  }
}
@media (min-width: 1024px){
  .lg\\:mt-0{
    margin-top: 0px;
  }
  .lg\\:block{
    display: block;
  }
  .lg\\:flex{
    display: flex;
  }
  .lg\\:hidden{
    display: none;
  }
  .lg\\:h-\\[360px\\]{
    height: 360px;
  }
  .lg\\:w-auto{
    width: auto;
  }
  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:flex-row{
    flex-direction: row;
  }
  .lg\\:px-\\[130px\\]{
    padding-left: 130px;
    padding-right: 130px;
  }
  .lg\\:px-\\[200px\\]{
    padding-left: 200px;
    padding-right: 200px;
  }
  .lg\\:pb-0{
    padding-bottom: 0px;
  }
  .lg\\:pb-24{
    padding-bottom: 6rem;
  }
  .lg\\:pt-16{
    padding-top: 4rem;
  }
  .lg\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }
  .lg\\:text-\\[36px\\]{
    font-size: 36px;
  }
}
@media (min-width: 1280px){
  .xl\\:w-1\\/2{
    width: 50%;
  }
  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .xl\\:px-\\[200px\\]{
    padding-left: 200px;
    padding-right: 200px;
  }
  .xl\\:px-\\[400px\\]{
    padding-left: 400px;
    padding-right: 400px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/index.scss","webpack://./src/components/toggle/style.scss"],"names":[],"mappings":"AACA;;CAAA;AAAA;;;CAAA;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;AAAA;;EAAA,gBAAA;AAAA;AAAA;;;;;;;;CAAA;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;AAAA;;;;CAAA;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,0BAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;AAAA;;CAAA;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,mBAAA;AAAA;AAAA;;;;;CAAA;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,cAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;;;;CAAA;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;AAAA;;;;CAAA;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,oBAAA;AAAA;AAAA;;;CAAA;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,aAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,YAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;;CAAA;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;AAAA;EAAA,UAAA;AAAA;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;;;CAAA;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,eAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;AAAA;;;;CAAA;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;AACA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AACA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,kBAAA;EAAA,wBAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,+DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA,mCAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,6DAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,0EAAA;EAAA,8FAAA;EAAA;AAAA;AAAA;EAAA,mDAAA;EAAA,2DAAA;EAAA;AAAA;AAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA;AAAA;AAAA;EAAA,6EAAA;EAAA,iGAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,gFAAA;EAAA,oGAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,yGAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,mGAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gKAAA;EAAA,wJAAA;EAAA,iLAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAGA;;EAEE,yCAAA;EACA,WAAA;EACA,YAAA;ACDF;;ADIA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;ACDF;;ADIA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;ACDF;;ADIA;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;ACDF;;ADIA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;ACDF;;ADIA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;ACDF;;ADIA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;ACDF;;ADKA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;ACFF;;ADKA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;ACFF;;ADKA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;ACFF;;ADKA;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;ACFF;;ADKA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;ACFF;;ADKA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;ACFF;;ADKA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;ACFF;;ADKA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;ACFF;;ADKA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;ACFF;;ADKA;EACE,kDAAA;ACFF;;ADKA;EACE,yFAAA;ACFF;;ADKA;EACE,2FAAA;ACFF;;ADKA;EACE,8FAAA;ACFF;;ADKA;EACE,8FAAA;ACFF;;ADKA;EACE,sDAAA;ACFF;;ADKA;EACE,sDAAA;ACFF;;ADKA;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;ACFF;;ADKA;EACE,WAAA;EACA,YAAA;EACA,WAAA;ACFF;;ADKA;EACE,6BAAA;EACA,oBAAA;ACFF;;ADKA;EACE,oBAAA;EACA,6BAAA;EACA,4BAAA;EACA,yBAAA;ACFF;;ADKA;EACE;IACI,uBAAA;ECFJ;EDIA;IACI,yBAAA;ECFJ;AACF;ADKA;EACE,sCAAA;ACHF;;ADMA;EACE,YAAA;EACA,cAAA;EACA,gBAAA;ACHF;;AAtKI;EACE,cAAA;AAyKN;AAtKI;EACE,cAAA;AAwKN;AApKE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,sCAAA;AAsKJ;AApKI;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AAsKN;AA/JI;EACE,yBAAA;AAiKN;AA5JI;EACE,yBAAA;AA8JN;AA5JM;EACE,UAAA;AA8JR;AAzJE;EACE,mBAAA;AA2JJ;AAxJM;;EAEE,cAAA;AA0JR;AArJE;EACE,UAAA;EACA,QAAA;EACA,UAAA;AAuJJ;ADvNQ;EAAA,sBCuNP;EDvNO;ACuNP;ADvNO;EAAA,kBCuNP;EDvNO;ACuNP;ADvNO;EAAA,kBCuNP;EDvNO;ACuNP;ADvNO;EAAA,6ECuNP;EDvNO,iGCuNP;EDvNO;ACuNP;ADvNO;EAAA,kBCuNP;EDvNO,kBCuNP;EDvNO;ACuNP;ADvNO;EAAA,kBCuNP;EDvNO;ACuNP;ADvNO;EAAA;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA,oBCuNP;IDvNO;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA,iBCuNP;IDvNO;ECuNP;EDvNO;IAAA,eCuNP;IDvNO;ECuNP;EDvNO;IAAA,mBCuNP;IDvNO;ECuNP;AAAA;ADvNO;EAAA;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA,iBCuNP;IDvNO;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA,kBCuNP;IDvNO;ECuNP;EDvNO;IAAA,kBCuNP;IDvNO;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA,iBCuNP;IDvNO;ECuNP;EDvNO;IAAA,oBCuNP;IDvNO;ECuNP;EDvNO;IAAA,kBCuNP;IDvNO;ECuNP;EDvNO;IAAA,oBCuNP;IDvNO;ECuNP;EDvNO;IAAA,kBCuNP;IDvNO;ECuNP;EDvNO;IAAA,qBCuNP;IDvNO;ECuNP;EDvNO;IAAA,oBCuNP;IDvNO;ECuNP;EDvNO;IAAA,kBCuNP;IDvNO;ECuNP;EDvNO;IAAA,qBCuNP;IDvNO;ECuNP;EDvNO;IAAA,mBCuNP;IDvNO;ECuNP;EDvNO;IAAA,kBCuNP;IDvNO;ECuNP;EDvNO;IAAA,kBCuNP;IDvNO;ECuNP;EDvNO;IAAA,kBCuNP;IDvNO;ECuNP;EDvNO;IAAA,kBCuNP;IDvNO;ECuNP;EDvNO;IAAA,mBCuNP;IDvNO;ECuNP;EDvNO;IAAA,iBCuNP;IDvNO;ECuNP;EDvNO;IAAA,iBCuNP;IDvNO;ECuNP;EDvNO;IAAA,mBCuNP;IDvNO;ECuNP;EDvNO;IAAA,iBCuNP;IDvNO;ECuNP;EDvNO;IAAA,iBCuNP;IDvNO;ECuNP;EDvNO;IAAA,oBCuNP;IDvNO;ECuNP;EDvNO;IAAA,mBCuNP;IDvNO;ECuNP;EDvNO;IAAA,oBCuNP;IDvNO;ECuNP;EDvNO;IAAA,oBCuNP;IDvNO;ECuNP;EDvNO;IAAA,kBCuNP;IDvNO;ECuNP;EDvNO;IAAA,iBCuNP;IDvNO;ECuNP;EDvNO;IAAA,iBCuNP;IDvNO;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA,iBCuNP;IDvNO;ECuNP;EDvNO;IAAA,mBCuNP;IDvNO;ECuNP;EDvNO;IAAA,kBCuNP;IDvNO;ECuNP;EDvNO;IAAA,eCuNP;IDvNO;ECuNP;EDvNO;IAAA,kBCuNP;IDvNO;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA,eCuNP;IDvNO;ECuNP;EDvNO;IAAA,mBCuNP;IDvNO;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;AAAA;ADvNO;EAAA;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA,mBCuNP;IDvNO;ECuNP;EDvNO;IAAA,mBCuNP;IDvNO;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA,eCuNP;IDvNO;ECuNP;EDvNO;IAAA;ECuNP;AAAA;ADvNO;EAAA;IAAA;ECuNP;EDvNO;IAAA;ECuNP;EDvNO;IAAA,mBCuNP;IDvNO;ECuNP;EDvNO;IAAA,mBCuNP;IDvNO;ECuNP;AAAA","sourcesContent":["@import url('https://api.fontshare.com/v2/css?f[]=general-sans@701,200,500,301,201,300,601,600,401,501,400,700&display=swap');\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n\nhtml,\nbody {\n  font-family: 'General Sans', 'Sans Serif';\n  width: 100%;\n  height: 100%;\n}\n\n.heading-64 {\n  font-weight: 700;\n  font-size: 64px;\n  line-height: 80px;\n}\n\n.heading-48 {\n  font-weight: 600;\n  font-size: 48px;\n  line-height: 57.6px;\n}\n\n.heading-36 {\n  font-weight: 600;\n  font-size: 36px;\n  line-height: 44.28px;\n}\n\n.heading-24 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 32.4px;\n}\n\n.heading-16 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n}\n\n.heading-18{\n  font-weight: 600;\n  font-size: 18px;\n  line-height: normal;\n\n}\n\n.label-18 {\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24.3px;\n}\n\n.label-16 {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n}\n\n.label-14 {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 16.1px;\n}\n\n.label-12 {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 12.48px;\n}\n\n.text-18 {\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 24.3px;\n}\n\n.text-16 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n}\n\n.text-14 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 19.6px;\n}\n\n.text-12 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 15.6px;\n}\n\n.text-cta {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.shadow-xs {\n  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n}\n\n.shadow-sm {\n  box-shadow: 0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06);\n}\n\n.shadow-md {\n  box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.10), 0px 2px 4px -2px rgba(16, 24, 40, 0.06);\n}\n\n.shadow-lg {\n  box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);\n}\n\n.shadow-xl {\n  box-shadow: 0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03);\n}\n\n.shadow-2xl {\n  box-shadow: 0px 24px 48px -12px rgba(16, 24, 40, 0.18);\n}\n\n.shadow-3xl {\n  box-shadow: 0px 32px 64px -12px rgba(16, 24, 40, 0.14);\n}\n\n.horizontal-divider {\n  height: 1px;\n  width: 100%;\n  background: theme('colors.grey-50');\n  opacity: 0.2;\n}\n\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n  z-index: 10;\n}\n\n::-webkit-scrollbar-track {\n  background-color: transparent;\n  border-radius: 100px;\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 100px;\n  border: 2px solid transparent;\n  background-clip: content-box;\n  background-color: theme('colors.grey-30');\n}\n\n@keyframes spin {\n  from {\n      transform: rotate(0deg);\n  }\n  to {\n      transform: rotate(360deg);\n  }\n}\n\n.loader-icon {\n  animation: spin 1000ms linear infinite;\n}\n\n.required::after {\n  content: '*';\n  color: theme('colors.error');\n  margin-left: 2px;\n}\n","@use '../../styles/index';\n\n.toggle-wrapper {\n  .label-wrapper {\n    .label {\n      color: theme('colors.black');\n    }\n\n    .sub-text {\n      color: theme('colors.grey-70');\n    }\n  }\n\n  .toggle-select {\n    width: 44px;\n    height: 24px;\n    border-radius: 50px;\n    background-color: theme('colors.grey-30');\n    transition: background-color .5s ease;\n\n    &::after {\n      content: '';\n      position: absolute;\n      background-color: theme('colors.white');\n      border-radius: 50%;\n      top: 2px;\n      left: 2px;\n      width: 20px;\n      height: 20px;\n\n      @extend .shadow-xs;\n    }\n  }\n\n  &:not(.disabled, .checked):hover {\n    .toggle-select {\n      background-color: theme('colors.grey-50');\n    }\n  }\n\n  &.checked {\n    .toggle-select {\n      background-color: theme('colors.primary-green');\n\n      &::after {\n        left: 22px;\n      }\n    }\n  }\n\n  &.disabled {\n    cursor: not-allowed;\n\n    .label-wrapper {\n      .label,\n      .sub-text {\n        color: theme('colors.grey-50');\n      }\n    }\n  }\n\n  .checkmark {\n    right: 5px;\n    top: 5px;\n    z-index: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
